<div [niceLoadingOverlay]="loading">
    <div fxLayoutAlign="column">
        <zxing-scanner
            [formats]="[4, 5, 7, 11]"
            (scanSuccess)="onScanned($event)"
        ></zxing-scanner>
    </div>
</div>
